import React, { useEffect } from 'react';
import { Sparkles, CheckCircle2 } from 'lucide-react';

interface ToastProps {
  message: string | null;
  onClose: () => void;
  type?: 'info' | 'success';
}

export const Toast: React.FC<ToastProps> = ({ message, onClose, type = 'info' }) => {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, 3200);
    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="fixed bottom-22 md:bottom-8 left-1/2 -translate-x-1/2 z-50 animate-bounce-in max-w-[90vw] pointer-events-none">
      <div className="bg-[#281333]/98 text-white px-5 py-3 rounded-2xl shadow-[0_10px_35px_rgba(0,0,0,0.6),0_0_25px_rgba(255,183,3,0.35)] flex items-center gap-3 text-sm font-black border-2 border-[#ffd166]/70 backdrop-blur-xl">
        <div className="w-7 h-7 rounded-xl bg-gradient-to-br from-[#ffd166] to-[#ff3366] flex items-center justify-center text-sm shadow-md shrink-0">
          {type === 'success' ? '🎉' : '✨'}
        </div>
        <span className="text-[#fff8ee] leading-snug">{message}</span>
      </div>
    </div>
  );
};
